<template>
  <div class="home">
    <header
      v-bind:class="
        'b-header' + (!showAgeForm && this.kidsAgeM !== '' && this.kidsAgeM >= 0 ? ' b-header--clickable' : '')
      "
      v-on:click="showAgeForm = true"
    >
      <div
        v-if="!(showAgeForm || (this.kidsAgeM !== '' && this.kidsAgeM >= 0))"
        class="btn btn-light btn-lg btn-block"
        v-on:click="showAgeForm = true"
      >
        {{ $t('enter_age') }}
      </div>
      <KidsAgeForm v-if="showAgeForm" v-on:myDate="getDate" v-bind:theDate="kidDOB" />
      <h2 style="margin-bottom:0" v-if="!showAgeForm && this.kidsAgeM !== '' && this.kidsAgeM >= 0">
        {{$t('age') }} {{ kidsAgeFull }}
      </h2>
    </header>
    <main class="b-main">
      <p>
        {{ $t('desc1') }}
      </p>
      <p>
        {{ $t('desc2') }}
      </p>
      <br /><br />
      <router-link
        class="btn btn-outline-primary btn-lg btn-block"
        v-if="!showAgeForm && this.kidsAgeM !== '' && this.kidsAgeM >= 0"
        v-bind:to="{
          name: 'Fields',
        }"
        >{{ $t('choose_field') }}</router-link
      >
    </main>
  </div>
</template>

<i18n>
  {
  "el": {
  "age": "Ηλικία",
  "enter_age": "Εισάγετε την ηλικία του παιδιού",
  "desc1": "Ο Mr.Blue Developmental Skills είναι μια εφαρμογή που δημιουργήθηκε για να βοηθήσει τους γονείς να εντοπίζουν τυχόν δυσκολίες που αφορούν στις πιο συχνές διαταραχές. Αποτελεί το πρώτο ψηφιακό εργαλείο ανίχνευσης δυσκολιών, ειδικά σχεδιασμένο για γονείς. Οι γονείς πολύ εύκολα απαντούν σε δέκα απλές ερωτήσεις. Το αποτέλεσμα των απαντήσεών τους μορφοποιείται σε ένα γράφημα, τον Mr. Blue. Ο Mr. Blue απαντάει στο καθημερινό ερώτημα των γονέων: 'Αντιμετωπίζει το παιδί μου δυσκολίες που πρέπει να διερευνήσω;'",
  "desc2": "Εμπνευστής της εφαρμογής είναι ο λογοθεραπευτής απο την Θεσσαλονίκη Γιάννης Κυβρακίδης ο οποίος έχει την επιστημονική επιμέλεια και οργάνωση της εφαρμογής. Οι τομείς που διερευνώνται απο την εφαρμογή είναι: Καθυστέρηση λόγου,άρθρωση-φωνολογία, επικοινωνιακές δυσκολίες,ροή ομιλίας, ελλειμματική προσοχή με ή χωρίς υπερκινητικότητα, τομείς έργου-εργοθεραπεία, παιδιατρική ανίχνευση, σχολική ετοιμότητα. Η επιμέλεια των ερωτηματολογίων στον τομέα ανίχνευσης της Εργοθεραπείας ολοκληρώθηκε απο την Άννα Σαμψωνίδου Εργοθεραπεύτρια MA, OTR, επιστημονική διευθύντρια των κέντρων Συνεργασία στις πόλεις Θεσσαλονίκη και Κατερίνη, και τον Δημοσθένη Λυγούρα Εργοθεραπευτή Msc/cand. Την επιμέλεια της παιδιατρικής ανίχνευσης πραγματοποίησε ο παιδίατρος Καμπούρας Αστέριος,του παιδιατρικού Τμήματος 424 ΓΣΝΕ Θεσσαλονίκης. Η επιμέλεια στην Αγγλική γλώσσα ολοκληρώθηκε απο τον Νεκτάριο Κοντολέων καθηγητή Αγγλικής γλώσσας στη Θεσσαλονίκη με μεταπτυχιακό στην Διδακτική της Αγγλικής γλώσσας. ",
  "choose_field": "Επιλέξτε τομέα διερεύνησης"
  },
  "en": {
  "age": "Age",
  "enter_age": "Enter your child's day of birth",
  "desc1": "Mr. Blue is a tool for the detection of children's communication difficulties in their parents hands. Your answers are personal and private. Based on your answers, Mr. Blue forms a graph that comprises blue and grey parts. The grey parts correspond to the skills that your child hasn't acquired yet, while the blue to the acquired ones. The app creates an image file for multiple uses. Every child have their own growth rate. The app helps you detect any deviations and neither assesses nor examines your child.",
  "desc2": "The formulation of the questionnaires in the field of detection of Occupational Therapy was undertaken by Anna Sampsonidou, Occupational Therapist MA, OTR, Scientific Director of ''Synergasia'' centers in Thessaloniki and Katerini, and Demosthenes Lygouras, Occupational Therapist, Msc / cand.  The supervision of the pediatric detection was undertaken by pediatrician Kabouras Asterios, of the pediatric department 424 GSNE Thessaloniki. The translation to English was completed by Nektarios Kontoleon, a teacher of English in Thessaloniki with a Master's degree in TESOL.",
  "choose_field": "Proceed with the assessment"
  }
  }
</i18n>

<script>
/**
 * VUEX
 */
import { mapState, mapMutations } from 'vuex'

/**
 * Components
 * @ is an alias to /src
 */
import KidsAgeForm from '@/components/KidsAgeForm.vue'
import i18n from '../i18n'

export default {
  name: 'Home',
  title: i18n.locale === 'en' ? 'Main' : 'Αρχική',
  inherit: true,
  data() {
    return {
      showAgeForm: false
    }
  },
  computed: {
    ...mapState(['kidDOB', 'kidsAgeM', 'kidsAgeFull']),
    ...mapMutations(['setKidsAge'])
  },
  components: {
    KidsAgeForm
  },
  methods: {
    getDate: function($date) {
      /**
       * TODO: DOCUMENT THIS
       * !SHOULD IMPROVE
       */
      this.showAgeForm = false
      this.$store.commit('setKidsAge', $date)
    }
  }
}
</script>
